/**
 * Horizontally scrolls an element into view
 * @param element - the element to scroll into view
 */
export function horizontallyScrollElementIntoView(element: HTMLElement) {
    if (!element) {
        return;
    }

    const container: HTMLElement = element.parentElement;
    const left = element.offsetLeft - container.offsetLeft;
    container.scrollTo({ left, behavior: "smooth" });
}
